import React from 'react';
import { authenticationService } from 'auth/authenticationService.js'

import { withRouter } from 'react-router-dom'
import { RutValidator } from "adds/RutValidator.js"

import ContribuyenteVista from './ContribuyenteVista.js'

import {
  Box,
  Typography,
  TextField, FormControl, MenuItem, Select,
  Button,
  Divider,
  InputLabel, Grid,
  Chip,
  Autocomplete

} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DoneIcon from '@mui/icons-material/Done';
import WarningIcon from '@mui/icons-material/Warning';
// import CompareArrowsIcon from '@mui/icons-material/CompareArrows';

// Teléfono obligatorio: desactivado temporalmente (mismo interruptor en backend/permisos/permiso/utils.py)
export const TELEFONO_OBLIGATORIO = false;

// 9 dígitos, o 11 dígitos con prefijo 56 (se aceptan espacios y '+')
const telefonoValido = (telefono) => {
  const digitos = String(telefono).replace(/\D/g, '');
  return digitos.length === 9 || (digitos.length === 11 && digitos.startsWith('56'));
}

class Contribuyente extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      html: {
        view: false,
        form: false,
        search: false,
        contribuyente_anterior: false,
      },
      data: {
      },
      contribuyente_anterior: {
      },
      contribuyente_busqueda: null,
      error: {
        errors: false,
        rut: false,
        dv: false,
        email: false,
        telefono: false,
        tipo: false,
        nombres: false,
        apellido_paterno: false,
      },
      filters: {
        rut: ''
      },
      input_comuna: '',
      selected_comuna: null,
      comunas: [],
      feedback: {
        rut: '',
        dv: '',
        tipo: '',
        email: '',
        telefono: '',
        nombres: '',
        apellido_paterno: '',
      },
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleRutChange = this.handleRutChange.bind(this);
    this.handleSearchContribuyente = this.handleSearchContribuyente.bind(this);
    this.handleTraspasar = this.handleTraspasar.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleEditForm = this.handleEditForm.bind(this);
    this.handleCancelEditForm = this.handleCancelEditForm.bind(this);
    this.loadComunas = this.loadComunas.bind(this);

    this.handleComunaChange = this.handleComunaChange.bind(this);

    // console.log(0)

  }
  loadComunas() {
    return (
      authenticationService.fetchPublic({
        url: '/api/comuna/',
        method: 'GET'
      })
        .then((result) => {
          this.setState({ comunas: result }, () => {
            // console.log(this.state)
          });
        })
        .catch(err => {

        })
    )
  }
  componentDidUpdate(prevProps) {
    // console.log(2, this.props)
    let prop_name = 'contribuyente'

    const matches = (obj, source) =>
      Object.keys(source).every(key => obj.hasOwnProperty(key) && obj[key] === source[key]);

    if ((this.props[prop_name] && prevProps[prop_name] &&
      !matches(this.props[prop_name], prevProps[prop_name])) ||
      this.props.forzarFormulario !== prevProps.forzarFormulario) {

      this.componentDidMount();
      // console.log('entra');
    }
  }
  componentDidMount() {
    // console.log(1)
    this.loadComunas().then(() => {
      if ('contribuyente' in this.props && this.props.contribuyente) {

        // console.log('entra2')
        // console.log(this.props.contribuyente)
        let selected_comuna = this.props.contribuyente.comuna_id !== null ? this.state.comunas.find(o => o.id === this.props.contribuyente.comuna_id) : null;

        this.setState({
          data: this.props.contribuyente
        }, () => {
          const html = this.state.html;
          // Si faltan datos obligatorios, el formulario se abre directamente
          html.form = this.props.forzarFormulario ? true : false;
          html.view = !html.form;
          html.search = true;

          this.setState({
            html: html,
            selected_comuna: selected_comuna
          });
        })
      }
      else {
        this.setState(prevState => ({
          html: {
            ...prevState.html,
            search: false,
            form: false,
            view: false,
            contribuyente_anterior: false
          }
        }));
      }
    });
    // console.log(this.props.location.pathname)
  }

  handleComunaChange(event, newValue) {
    this.setState(prevState => ({
      selected_comuna: newValue,
      data: {
        ...prevState.data,
        comuna_id: newValue.id
      }
    }));

  }

  handleInputChange(event) {
    const { data } = { ...this.state };
    const currentState = data;
    const { name, value } = event.target;


    if (name === 'email') {
      if (value !== '' && /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
        this.setState(prevState => ({
          feedback: {
            ...prevState.feedback,
            email: ''
          },
          error: {
            ...prevState.error,
            email: false
          }
        }));

      }
      else {
        this.setState(prevState => ({
          feedback: {
            ...prevState.feedback,
            email: 'Email con formato incorrecto'
          },
          error: {
            ...prevState.error,
            email: true
          }
        }));
      }

      currentState[name] = value.toLowerCase();
      this.setState({ data: currentState }, () => {
      });
    }
    else if (name === 'rut') {
      let valid = false
      if (value !== null && value !== '') {
        valid = RutValidator.validate(value)
      }
      else {
        valid = false
      }

      currentState[name] = RutValidator.format(value);
      this.setState(prevState => ({
        data: currentState,
        error: {
          ...prevState.error,
          rut: !valid
        },
        feedback: {
          ...prevState.feedback,
          rut: valid ? "" : "Rut inválido"
        }
      }));


    }
    else if (name === 'telefono') {

      currentState[name] = value;
      // Si escribe algo, limpiamos el error
      this.setState(prevState => ({
        data: currentState,
        error: { ...prevState.error, telefono: false },
        feedback: { ...prevState.feedback, telefono: '' }
      }));

    }
    else {
      // currentState[name] = value;
      // this.setState({ data: currentState },()=>{
      // });
      currentState[name] = value;

      // Actualizamos el dato Y limpiamos el error de ese campo específico
      this.setState(prevState => ({
        data: currentState,
        error: { ...prevState.error, [name]: false },      // Limpia error
        feedback: { ...prevState.feedback, [name]: '' }    // Limpia mensaje
      }));
    }


  }
  handleRutChange(event) {

    const { filters } = { ...this.state };
    const currentState = filters;
    const { name, value } = event.target;
    currentState[name] = value;
    this.setState({ filters: currentState }, () => {
    });

  }
  handleSearchContribuyente(event) {


    event.preventDefault();

    console.log('entra')
    authenticationService.fetchPublic({
      url: '/permisos/contribuyente/?rut=' + this.state.filters.rut,
      method: 'GET',
    })
      .then(response => {
        if (response.data.length > 0) {

          this.setState(prevState => ({
            html: {
              ...prevState.html,
              search_result: false,
            },
            contribuyente_busqueda: response.data[0],
          }), () => {
            this.setState(prevState => ({
              html: {
                ...prevState.html,
                search_result: true,
              },
            }));

          });

        }
        else {
          this.setState(prevState => ({
            html: {
              ...prevState.html,
              search_result: false,
            },
          }));
        }
      });
  }

  handleTraspasar(event, tipo) {
    if (event) {
      event.preventDefault();
    }

    if (tipo === 'anterior') {
      const params = {
        es_contribuyente_anterior: true
      }
      this.props.updatePermiso(null, params).then(() => {
        this.setState(prevState => ({
          html: {
            ...prevState.html,
            view: true,
            form: false,
          },
          contribuyente_busqueda: null
        }));
      });
    }
    if (tipo === 'busqueda') {
      const params = {
        asignar_contribuyente: this.state.contribuyente_busqueda.contribuyente_uuid
      }
      this.props.updatePermiso(null, params).then(() => {
        this.setState(prevState => ({
          html: {
            ...prevState.html,
            view: true,
            form: false,
          },
          contribuyente_busqueda: null
        }));
      });
    }
  }

  handleSubmit(event) {
    if (event) {
      event.preventDefault();
    }
    let ok = true;
    if (this.state.error.rut || !this.state.data.rut || !RutValidator.validate(String(this.state.data.rut))) {
      this.setState(prevState => ({
        error: { ...prevState.error, rut: true },
        feedback: { ...prevState.feedback, rut: 'Debes ingresar un rut válido (es obligatorio).' }
      }));
      ok = false
    }
    if (this.state.error.email || !this.state.data.email || this.state.data.email.trim() === '') {
      this.setState(prevState => ({
        error: { ...prevState.error, email: true },
        feedback: { ...prevState.feedback, email: prevState.feedback.email ? prevState.feedback.email : 'El email es obligatorio.' }
      }));
      ok = false
    }
    // AGREGAR NUEVAS VALIDACIONES AQUÍ
    const telefonoVacio = !this.state.data.telefono || String(this.state.data.telefono).trim() === '';
    if (telefonoVacio && !TELEFONO_OBLIGATORIO) {
      // Opcional: vacío es válido; si viene, se valida el formato
    }
    else if (telefonoVacio) {
      this.setState(prevState => ({
        error: { ...prevState.error, telefono: true },
        feedback: { ...prevState.feedback, telefono: 'El teléfono es obligatorio.' }
      }));
      ok = false;
    }
    else if (!telefonoValido(this.state.data.telefono)) {
      this.setState(prevState => ({
        error: { ...prevState.error, telefono: true },
        feedback: { ...prevState.feedback, telefono: 'Teléfono inválido. Debe tener 9 dígitos (Ejemplo: 912345678).' }
      }));
      ok = false;
    }
    if (!this.state.data.tipo || this.state.data.tipo === '' || this.state.data.tipo === '0') {
      this.setState(prevState => ({
        error: { ...prevState.error, tipo: true },
        feedback: { ...prevState.feedback, tipo: 'Debe seleccionar un tipo de contribuyente' }
      }));
      ok = false;
    }
    if (this.state.data.tipo === 'Persona Natural') {
      if (!this.state.data.nombres || this.state.data.nombres.trim() === '') {
        this.setState(prevState => ({
          error: { ...prevState.error, nombres: true },
          feedback: { ...prevState.feedback, nombres: 'El nombre es obligatorio.' }
        }));
        ok = false;
      }
      if (!this.state.data.apellido_paterno || this.state.data.apellido_paterno.trim() === '') {
        this.setState(prevState => ({
          error: { ...prevState.error, apellido_paterno: true },
          feedback: { ...prevState.feedback, apellido_paterno: 'El apellido paterno es obligatorio.' }
        }));
        ok = false;
      }
    }
    if (this.state.data.tipo === 'Empresa') {
      if (!this.state.data.nombre_empresa || this.state.data.nombre_empresa.trim() === '') {
        this.setState(prevState => ({
          error: { ...prevState.error, nombre_empresa: true },
          feedback: { ...prevState.feedback, nombre_empresa: 'El nombre es obligatorio.' }
        }));
        ok = false;
      }
    }
    // ------------------------
    // AGREGAR NUEVAS VALIDACIONES AQUÍ
    if (!ok) {
      this.setState(prevState => ({ error: { ...prevState.error, errors: true } }));
      return false;
    }

    let data = this.state.data
    data.rut = RutValidator.unformat(data.rut)

    let params = {
      field: 'contribuyente',
      contribuyente: data
    }

    this.props.updatePermiso(null, params).then((ok) => {
      if (ok === false) {
        return;
      }
      this.setState(prevState => ({
        html: {
          ...prevState.html,
          view: true,
          form: false,
        }
      }));

    }).catch(() => { });
  }

  handleEditForm(event, is_new = false) {
    this.setState(prevState => ({
      html: {
        ...prevState.html,
        view: false,
        form: true,
      }
    }));
  }

  handleCancelEditForm(event) {
    event.preventDefault();

    this.props.updatePermiso(null, {});
    this.setState(prevState => ({
      html: {
        ...prevState.html,
        view: true,
        form: false,
      }
    }));
  }



  render() {
    return (
      <Box p={1}>

        {/* Rescatar desde otro lado */}

        {this.state.html.search && this.props.interno &&
          <Box style={{ background: '#f2f2f2', borderRadius: '5px' }}>
            <Grid container>
              <Grid item sm={12} md={8}>
                {/* <Box>
                    <Box p={1}>
                      <Typography variant='overline'>Buscar un contribuyente anterior e importar datos</Typography>
                    </Box>

                    <Box p={1}>
                      <TextField  name='rut'
                                  id='rut'
                                  label='Rut'
                                  placeholder='Rut del contribuyente'
                                  maxLength='8'
                                  value={this.state.filters.rut}
                                  onChange={this.handleRutChange}
                                  variant="standard"
                                  />
                      <Button onClick={this.handleSearchContribuyente} color='primary'>
                        Buscar
                      </Button>
                    </Box>
                  
                    {this.state.html.search_result && this.state.contribuyente_busqueda &&
                      <Box p={1} style={{border:'1px', borderColor:'#DDDDDD'}} >
                        <ContribuyenteVista compact={true} titulo='' contribuyente={this.state.contribuyente_busqueda}/>
                        <Button onClick={(event)=>this.handleTraspasar(event, 'busqueda')}
                                startIcon={<CompareArrowsIcon/>}
                                >
                          Traspasar datos al permiso actual
                        </Button>
                      </Box>
                    }

                  </Box> */}
              </Grid>
              <Grid item sm={12} md={4}>

                {this.props.permiso.tipo === 'Renovación' && this.props.interno &&
                  ('currentUser' in authenticationService && authenticationService.currentUser !== null &&
                    ['admin'].filter(x => authenticationService.currentUser.groups.includes(x)).length > 0 &&
                    this.props.location.pathname !== '/' &&
                    [0, 1, 2].includes(this.props.permiso.contribuyente_validacion)
                  ) &&
                  ![4, 5, 6].includes(this.props.permiso.estado_consolidado) &&


                  <Box>
                    <Box p={1}>
                      <Typography variant='overline'>Contribuyente de renovación</Typography>
                    </Box>
                    <Button onClick={(event) => this.handleTraspasar(event, 'anterior')}>
                      Cargar contribuyente del año anterior
                    </Button>
                  </Box>

                }
              </Grid>
            </Grid>

          </Box>
        }



        {/* CASO SIEMPRE, es el formulario del proceso actual */}
        {this.state.html.form &&
          <Box>

            {!this.props.forzarFormulario &&
              <Box p={1} textAlign='right'>
                <Button color='secondary' variant='outlined' onClick={this.handleCancelEditForm}>
                  Cancelar editar
                </Button>
              </Box>
            }

            <Box p={1}>
              <Typography variant='h6'>Editar Contribuyente</Typography>
            </Box>

            <Box p={1}>
              <Typography variant='caption'>*Campos obligatorios</Typography>
            </Box>

            <Grid container>
              <Grid item sm={12} md={6}>

                <Box p={1}>
                  <TextField name='email'
                    id='email'
                    label='Email*'
                    placeholder='Email*'
                    fullWidth
                    maxLength='200'
                    value={this.state.data.email ? this.state.data.email : ''}
                    error={this.state.error.email}
                    helperText={this.state.feedback.email}
                    onChange={this.handleInputChange}
                    variant="standard"
                  />
                </Box>
                <Box p={1}>
                  <TextField name='rut'
                    id='rut'
                    label='Rut del contribuyente*'
                    placeholder='Rut del contribuyente*'
                    fullWidth
                    maxLength='8'
                    value={this.state.data.rut ? RutValidator.format(this.state.data.rut) : ''}
                    error={this.state.error.rut}
                    helperText={this.state.feedback.rut}
                    onChange={this.handleInputChange}
                    variant="standard"
                  />

                </Box>
              </Grid>
              <Grid item sm={12} md={6}>
                <Box p={1}>
                  <TextField name='telefono'
                    id='telefono'
                    label={TELEFONO_OBLIGATORIO ? 'Teléfono*' : 'Teléfono'}
                    placeholder={(TELEFONO_OBLIGATORIO ? 'Teléfono*' : 'Teléfono') + ' (Ejemplo: 912345678)'}
                    fullWidth
                    maxLength='200'
                    value={this.state.data.telefono ? this.state.data.telefono : ''}
                    error={this.state.error.telefono}
                    helperText={this.state.feedback.telefono}
                    onChange={this.handleInputChange}
                    variant="standard"
                  />
                </Box>

                <Box p={1}>
                  <FormControl fullWidth={true}
                    error={this.state.error.tipo}
                  >
                    <InputLabel id="tipo_label">Tipo contribuyente*</InputLabel>
                    <Select labelId="tipo_label"
                      id="tipo"
                      name="tipo"
                      value={this.state.data.tipo ? this.state.data.tipo : ''}
                      onChange={this.handleInputChange}
                      variant="standard"
                    >
                      {/* <MenuItem key='0' value='0'></MenuItem> */}
                      <MenuItem key='Persona Natural' value='Persona Natural'>Persona Natural</MenuItem>
                      <MenuItem key='Empresa' value='Empresa'>Empresa</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </Grid>
            </Grid>
            <Divider />
            <Grid container>
              <Grid item sm={12} md={6}>
                {this.state.data.tipo === 'Persona Natural' &&
                  <Box>
                    <Box p={1}>
                      <TextField name='nombres'
                        id='nombres'
                        label='Nombres*'
                        placeholder='Nombres*'
                        fullWidth
                        maxLength='200'
                        value={this.state.data.nombres ? this.state.data.nombres : ''}
                        error={this.state.error.nombres}
                        helperText={this.state.feedback.nombres}
                        onChange={this.handleInputChange}
                        variant="standard"
                      />
                    </Box>
                    <Box p={1}>
                      <TextField name='apellido_paterno'
                        id='apellido_paterno'
                        label='Apellido Paterno*'
                        placeholder='Apellido Paterno*'
                        fullWidth
                        maxLength='200'
                        value={this.state.data.apellido_paterno ? this.state.data.apellido_paterno : ''}
                        error={this.state.error.apellido_paterno}
                        helperText={this.state.feedback.apellido_paterno}
                        onChange={this.handleInputChange}
                        variant="standard"
                      />
                    </Box>
                    <Box p={1}>
                      <TextField name='apellido_materno'
                        id='apellido_materno'
                        label='Apellido Materno'
                        placeholder='Apellido Materno'
                        fullWidth
                        maxLength='200'
                        value={this.state.data.apellido_materno ? this.state.data.apellido_materno : ''}
                        error={this.state.error.apellido_materno}
                        helperText={this.state.feedback.apellido_materno}
                        onChange={this.handleInputChange}
                        variant="standard"
                      />
                    </Box>
                  </Box>
                }
                {this.state.data.tipo === 'Empresa' &&
                  <Box>
                    <Box p={1}>
                      <TextField name='nombre_empresa'
                        id='nombre_empresa'
                        label='Nombre de la Empresa*'
                        placeholder='Nombre de la Empresa*'
                        fullWidth
                        maxLength='200'
                        value={this.state.data.nombre_empresa ? this.state.data.nombre_empresa : ''}
                        error={this.state.error.nombre_empresa}
                        helperText={this.state.feedback.nombre_empresa}
                        onChange={this.handleInputChange}
                        variant="standard"
                      />
                    </Box>
                    <Box p={1}>
                      <TextField name='giro_empresa'
                        id='giro_empresa'
                        label='Giro de la Empresa'
                        placeholder='Giro de la Empresa'
                        fullWidth
                        maxLength='200'
                        value={this.state.data.giro_empresa ? this.state.data.giro_empresa : ''}
                        error={this.state.error.giro_empresa}
                        helperText={this.state.feedback.giro_empresa}
                        onChange={this.handleInputChange}
                        variant="standard"
                      />
                    </Box>
                  </Box>
                }
              </Grid>
              <Grid item sm={12} md={6}>
                <Box p={1}>
                  <TextField name='direccion_calle'
                    id='direccion_calle'
                    label='Calle'
                    placeholder='Calle'
                    fullWidth
                    maxLength='200'
                    value={this.state.data.direccion_calle ? this.state.data.direccion_calle : ''}
                    onChange={this.handleInputChange}
                    variant="standard"
                  />
                </Box>

                <Box p={1}>
                  <TextField name='direccion_numero'
                    id='direccion_numero'
                    label='Número'
                    placeholder='Número'
                    fullWidth
                    maxLength='200'
                    value={this.state.data.direccion_numero ? this.state.data.direccion_numero : ''}
                    onChange={this.handleInputChange}
                    variant="standard"
                  />
                </Box>

                <Box p={1}>
                  <TextField name='direccion_unidad'
                    id='direccion_unidad'
                    label='Departamento/Unidad'
                    placeholder='Departamento/Unidad'
                    fullWidth
                    maxLength='200'
                    value={this.state.data.direccion_unidad ? this.state.data.direccion_unidad : ''}
                    onChange={this.handleInputChange}
                    variant="standard"
                  />
                </Box>

                <Box p={1}>
                  <TextField name='direccion_poblacion'
                    id='direccion_poblacion'
                    label='Población/Villa'
                    placeholder='Población/Villa'
                    fullWidth
                    maxLength='200'
                    value={this.state.data.direccion_poblacion ? this.state.data.direccion_poblacion : ''}
                    error={this.state.error.direccion_poblacion}
                    onChange={this.handleInputChange}
                    variant="standard"
                  />
                </Box>



                <Box p={1}>
                  {this.state.comunas && this.state.comunas.length > 0 &&
                    <Autocomplete disablePortal
                      id="comuna"
                      name="comuna"
                      getOptionLabel={(option) => option.nombre}
                      isOptionEqualToValue={(option, value) => option.nombre === value.nombre}
                      options={this.state.comunas}
                      value={this.state.selected_comuna}
                      fullWidth
                      onChange={(event, newValue) => { this.handleComunaChange(event, newValue); }}
                      sx={{ width: 300 }}
                      renderInput={(params) => <TextField {...params}
                        fullWidth
                        variant="standard"
                        label="Comuna" />}
                    />
                  }
                </Box>
              </Grid>
            </Grid>
            {this.state.error.errors &&
              <Box sx={{ color: "#FF2222" }}>
                Hay errores en el formulario
              </Box>
            }
            <Box p={1} textAlign='right'>
              <Button onClick={this.handleSubmit} color='primary' variant='contained'>Guardar Cambios</Button>
            </Box>

          </Box>
        }

        {this.state.html.view &&
          <Box>
            {this.state.data.es_contribuyente_anterior && this.props.permiso.contribuyente_info_status &&
              <Box p={2}>

                <Chip size="small"
                  label='El contribuyente cargado es el mismo del año pasado. Como tal, de estar todos los datos no va a requerir aprobación.'
                  icon={<DoneIcon />}
                  fullWidth
                  style={{ backgroundColor: 'lightgreen' }}
                />

              </Box>
            }
            {this.state.data.es_contribuyente_anterior && !this.props.permiso.contribuyente_info_status &&
              <Box p={2} sx={{ backgroundColor: '#FFFFDD', height: '100%', borderRadius: "5px" }}>
                <Typography variant='caption'>
                  El contribuyente cargado es el mismo del año pasado, como tal por defecto está aprobado. Sin embargo si alguno de estos datos ya no corresponde, debes modificarlo.
                </Typography>
              </Box>
            }
            <ContribuyenteVista titulo='Datos del contribuyente' contribuyente={this.state.data} comunas={this.state.comunas} />

            {(([0, 2].includes(this.props.permiso.contribuyente_validacion) && !this.props.permiso.bloqueado)
              ||
              ('currentUser' in authenticationService && authenticationService.currentUser !== null &&
                ['admin'].filter(x => authenticationService.currentUser.groups.includes(x)).length > 0 &&
                this.props.location.pathname !== '/' &&
                [0, 1, 2].includes(this.props.permiso.contribuyente_validacion)
              )
            ) &&
              ![4, 5, 6].includes(this.props.permiso.estado_consolidado) &&
              <Button color='primary'
                variant='outlined'
                onClick={this.handleEditForm}
                startIcon={<EditIcon />}>
                Editar
              </Button>

            }

            {this.state.data.es_contribuyente_anterior && this.props.permiso.contribuyente_info_status &&
              <Box p={2} style={{ display: 'inline-block' }}>

                <Chip size="small"
                  label='Si editas el contenido, el contribuyente deberá ser aprobado'
                  icon={<WarningIcon />}
                  style={{ backgroundColor: 'lightyellow', border: "1px solid #DDDD55" }}
                />

              </Box>
            }
          </Box>

        }
      </Box>
    );
  }
}

export default withRouter(Contribuyente);